import React from "react";

import "./LabelPill.scss";

type LabelPillProps = {
  closable?: boolean;
  children: string;
};

const LabelPill = ({ closable = false, children }: LabelPillProps) => {
  return (
    <div className="label-pill">
      <span>{children}</span>
      {closable && (
        //   We don't use the ButtonIcon component here because the styling for it is vastly different and this small cross is not repeated elsewhere in the app.
        //   TODO: Remove the label pill when closed
        <button onClick={() => {}} className="material-icons label-pill__close">
          close
        </button>
      )}
    </div>
  );
};

export default LabelPill;
